import { render } from "./CreateL2NetworkForm.vue?vue&type=template&id=a154a260&scoped=true"
import script from "./CreateL2NetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateL2NetworkForm.vue?vue&type=script&lang=js"

import "./CreateL2NetworkForm.vue?vue&type=style&index=0&id=a154a260&lang=less&scoped=true"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a154a260"]])

export default __exports__